export const AUTH_USER = 'auth_user',
    UNAUTH_USER = 'unauth_user',
    AUTH_ERROR = 'auth_error',
    SWITCH_USER_ROLE = 'switch_user_role',
    FETCH_RESET_PASSWORD = 'fetch_reset_password',
    FETCH_RESET_PASSWORD_LOADING = 'fetch_reset_password_loading',
    FETCH_RESET_PASSWORD_SUCCESS = 'fetch_reset_password_success',
    FETCH_RESET_PASSWORD_FAIL = 'fetch_reset_password_fail';
